import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  HaulierInfo,
  FlexRow,
  GridRow,
  SubTitle,
  FlexRowEmpty,
  SubTitleBold,
} from "./HaulierView.styled";

const HaulierView = (props) => {
  const { t, data } = props;

  return (
    <HaulierInfo>
      {!!data?.id && (
        <>
          <GridRow column="1fr 1fr">
            <div>
              <FlexRow>
                <SubTitleBold>{t("LOGISTIC_FLOW")} :</SubTitleBold>
                <SubTitle>
                  {data.logisticFlow === null && t("NONE")}
                  {parseInt(data.logisticFlow, 10) === 1 &&
                    t("LOGISTIC_FLOW_ROUND_TRIP")}
                  {parseInt(data.logisticFlow, 10) === 2 &&
                    t("LOGISTIC_FLOW_RETURN_LOAD")}
                  {parseInt(data.logisticFlow, 10) === 3 &&
                    t("LOGISTIC_FLOW_ROUND_TRIP") +
                      "/" +
                      t("LOGISTIC_FLOW_RETURN_LOAD")}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("HAULIER_TRUCKS_TO_ORDER")} :</SubTitleBold>
                <SubTitle>
                  {!!data?.trucksToOrder !== null && data.trucksToOrder}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("HAULIER_DISTANCE_LIMIT")} :</SubTitleBold>
                <SubTitle>
                  {data?.maxDistancePerDay !== null &&
                    data.maxDistancePerDay + " " + t("GENERAL_UNIT_KM")}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("HAULIER_DRIVING_TIME_LIMIT")} :</SubTitleBold>
                <SubTitle>
                  {data?.maxTimePerDay !== null &&
                    data.maxTimePerDay + " " + t("MINUTES_ABREVIATED")}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>
                  {t("HAULIER_LOADING_DEPARTMENTS")} :
                </SubTitleBold>
                <SubTitle>
                  {data.loadingDepartments !== null &&
                  data?.loadingDepartments !== ""
                    ? data.loadingDepartments
                    : t("NONE")}
                </SubTitle>
              </FlexRow>
            </div>

            <div>
              <FlexRow>
                <SubTitleBold>{t("HAULIER_APPROVAL_TYPE")} :</SubTitleBold>
                <SubTitle>
                  {data?.approvalType.length > 0 &&
                    data.approvalType.map((type, index) => {
                      return (
                        <React.Fragment key={"approval-type-" + type.id}>
                          {(index ? ", " : "") + t(type.label)}
                        </React.Fragment>
                      );
                    })}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("HAULIER_APPROVAL_NUMBER")} :</SubTitleBold>
                <SubTitle>
                  {data?.approvalNumber !== null && data?.approvalNumber !== ""
                    ? data.approvalNumber
                    : "-"}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("HAULIER_APPROVAL_END_DATE")} :</SubTitleBold>
                <SubTitle>
                  {data?.approvalEndDate !== null &&
                  data?.approvalEndDate !== ""
                    ? data.approvalEndDate
                    : "-"}
                </SubTitle>
              </FlexRow>
              <FlexRowEmpty></FlexRowEmpty>
              <FlexRow>
                <SubTitleBold>
                  {t("HAULIER_UNLOADING_DEPARTMENTS")} :
                </SubTitleBold>
                <SubTitle>
                  {data.unloadingDepartments !== null &&
                  data?.unloadingDepartments !== ""
                    ? data.unloadingDepartments
                    : t("NONE")}
                </SubTitle>
              </FlexRow>
            </div>
          </GridRow>
        </>
      )}
    </HaulierInfo>
  );
};

HaulierView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(HaulierView);
